<template>
    <input type="checkbox" class="aup-switch" :class="{'switch-active': value}" v-model="localValue" :disabled="isDisabled"/>
</template>

<script>

export default {
    name: 'BaseSwitch',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        isDisabled: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        localValue() {
            this.$emit('input', this.localValue);
        }
    },
    data() {
        return {
            localValue: this.value,
        };
    }
};
</script>

<style lang="scss">
    @import "../../assets/scss/all";
    .aup-switch {
        background: $gray-300;
        border-radius: 50px;
        height: 28px;
        width: 55px;
        position: relative;
        border-width: 0;
        -webkit-appearance: none;
        transition: background ease-in-out .3s;
        min-width: 55px;
        &:hover {
            cursor: pointer;
        }
        &:focus {
            outline: 0;
        }
        &:after {
            content: "";
            position: absolute;
            left: 4px;
            top: 50%;
            transform: translateY(-50%);
            background: $sony-white;
            border-radius: 100%;
            width: 23px;
            height: 23px;
            transition: left ease-in-out .3s;
        }
        &.switch-active {
            background: $primary;
            &:after {
                left: 28px;
            }
        }
        &:disabled {
            opacity: 0.2;
            cursor: none;
        }
    }
</style>
